// test2387
(2387 && 0);
